var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('ToolBar',{class:_vm.currentPath}),(_vm.envTag && _vm.$route.name === 'Store')?_c('div',{staticClass:"env-tag"},[_vm._v(" "+_vm._s(_vm.envTag)+" ")]):_vm._e(),(!_vm.$store.state.maintenance.modal)?_c('div',{staticClass:"main-page"},[_c('router-view')],1):_vm._e(),_c('MyMaintenanceModal')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }